import * as actionTypes from './actionTypes';
import { Filters, NotificationCount, NotificationItem, NotificationStatus } from './types';

/*------------------------------------------------------------------------------------------------*/
/* Notification Fetch Actions                                                                     */
/*------------------------------------------------------------------------------------------------*/
/**
/**
 * fetchNotificationsRequest
 * Fetch notifications request action.
 */
export const fetchNotificationsRequest = (
  isFilterUpdate = false,
  shouldCheckForDuplicates = true,
) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_REQUEST,
  isFilterUpdate,
  shouldCheckForDuplicates,
});

/**
 * fetchNotificationsResponse
 * Fetch notification response action.
 */
export const fetchNotificationsResponse = (
  notifications: NotificationItem[],
  isFilterUpdate = false,
) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_RESPONSE,
  notifications,
  isFilterUpdate,
});

/**
 * fetchNotificationsError
 * Fetch notification response action.
 */
export const fetchNotificationsError = (error: string) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_ERROR,
  error,
});

/**
 * fetchNotificationsResponse
 * Fetch response for notification counts
 */
export const fetchNotificationCountResponse = (notificationCount: NotificationCount) => ({
  type: actionTypes.FETCH_NOTIFICATION_COUNT_RESPONSE,
  notificationCount,
});

/**
 * fetachNotificationsRequest
 * Fetch action for notification counts
 * @returns { Object } action.
 */
export const fetchNotificationCountRequest = () => ({
  type: actionTypes.FETCH_NOTIFICATION_COUNT_REQUEST,
});

/**
 * fetachNotificationsRequest
 * Fetch action for notification counts
 */
export const fetchNotificationCountError = (error: string) => ({
  type: actionTypes.FETCH_NOTIFICATION_COUNT_ERROR,
  error,
});

/**
 * updateNotificationsRequest
 * Updates a list of notifications.
 */
export const updateNotificationsRequest = (
  notifications: { notificationId: number; status: NotificationStatus }[],
  isAllReadRequest = false,
) => ({
  type: actionTypes.UPDATE_NOTIFICATIONS_REQUEST,
  notifications,
  isAllReadRequest,
});

/**
 * updateNotificationsResponse
 * Update notifications response
 */
export const updateNotificationsResponse = (notificationIds: number[]) => ({
  type: actionTypes.UPDATE_NOTIFICATIONS_RESPONSE,
  notificationIds,
});

/**
 * updateNotificationCenterFilters
 * Updates Notification center filters.
 */
export const updateNotificationCenterFilters = (filters: Filters, isFilterUpdate = false) => ({
  type: actionTypes.UPDATE_NOTIFICATION_CENTER_FILTERS,
  filters,
  isFilterUpdate,
});
